export enum PrescriptionRefillStatus {
  NEW = 'NEW',
  DONE = 'DONE'
}